// extracted by mini-css-extract-plugin
module.exports = {"organism__banner-list-section-container":"styles_organism__banner-list-section-container__YDcQh"};